// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconSymbolsFavoriteFilled_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 12L10.2635 11.3833L8.97159 7.24868L12 5V4H8L6.5 0H5.5L4 4H0V5L3.33098 7.24868L1.74152 11.3965L2.5 11.9907L6 9L9.5 12Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3253 15.4882L13.2698 14.7368L11.4797 9.62219L15 6.87295V5.54784L10.2989 5.54784L8.51979 0.655284H7.46194L5.68282 5.54784H1V6.84673L4.50203 9.62218L2.70213 14.7648L3.64041 15.4998L7.99086 12.3578L12.3253 15.4882Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8261 0.5L15.6059 8.14465H23V10.2283L17.4509 14.5108L20.2462 22.4972L18.7678 23.6733L11.9996 18.7851L5.19578 23.699L3.7334 22.5535L6.54833 14.5108L1 10.1446V8.12729L8.39332 8.14465L11.1732 0.5H12.8261Z" class="svg-bg"/>
</svg>
`;
/**
 * IconSymbolsFavoriteFilled is a generated icon component.
 */
let IconSymbolsFavoriteFilled = IconSymbolsFavoriteFilled_1 = class IconSymbolsFavoriteFilled extends IconBaseElement {
    render() {
        return html `${IconSymbolsFavoriteFilled_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconSymbolsFavoriteFilled.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconSymbolsFavoriteFilled = IconSymbolsFavoriteFilled_1 = __decorate([
    customElement('zui-icon-symbols-favorite-filled')
], IconSymbolsFavoriteFilled);
export { IconSymbolsFavoriteFilled };
